export default __webpack_public_path__ + "static/media/orange_button.b9bd7091.png";